import * as C from '../constants';

export default {

  /**
   * @param state
   */
  [C.REVIEW_ITEMS_PENDING](state) {
    state.approval = { ...state.approval, loading: true, error: false };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_ITEMS_SUCCESS](state, payload) {
    const reviewArr = state.approval.items.reviews.concat(payload.reviews);
    state.approval = {
      loading: false,
      error: false,
      items: {
        reviews: reviewArr,
        hasMore: payload.hasMore,
        offset: payload.offset,
      },
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_ITEMS_FAILURE](state) {
    state.approval = { ...state.approval, loading: false, error: true, items: [] };
  },

  /**
   * @param state
   */
  [C.REVIEW_FILTER_ITEMS_PENDING](state) {
    state.filter = {
      ...state.filter,
      loading: true,
      error: false,
      items: [],
      selectedBrands: [],
      selectedDomains: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_FILTER_ITEMS_SUCCESS](state, payload) {
    state.filter = {
      ...state.filter,
      loading: false,
      error: false,
      items: payload,
      selectedBrands: [],
      selectedDomains: [],
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_FILTER_ITEMS_FAILURE](state) {
    state.filter = {
      ...state.filter,
      loading: false,
      error: true,
      items: [],
      selectedBrands: [],
      selectedDomains: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_FILTER_UPDATE_SELECTED_BRANDS](state, payload) {
    state.filter = { ...state.filter, selectedBrands: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_FILTER_UPDATE_SELECTED_DOMAINS](state, payload) {
    state.filter = { ...state.filter, selectedDomains: payload };
  },

  /**
   * @param state
   */
  [C.REVIEW_FILTER_SITE_ITEMS_PENDING](state) {
    state.filter = {
      ...state.filter,
      loading: true,
      error: false,
      sites: [],
      selectedSites: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_FILTER_SITE_ITEMS_SUCCESS](state, payload) {
    state.filter = {
      ...state.filter,
      loading: false,
      error: false,
      sites: payload,
      selectedSites: [],
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_FILTER_SITE_ITEMS_FAILURE](state) {
    state.filter = {
      ...state.filter,
      loading: false,
      error: true,
      sites: [],
      selectedSites: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_FILTER_UPDATE_SELECTED_SITES](state, payload) {
    state.filter = { ...state.filter, selectedSites: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_APPROVAL_STATUS_APPROVE_SUCCESS](state, payload) {
    state.approval = { ...state.approval, loading: false, error: false };
    state.approval.items.reviews = payload;
  },

  /**
   * @param state
   */
  [C.REVIEW_APPROVAL_STATUS_APPROVE_FAILURE](state) {
    state.approval = { ...state.approval, loading: false, error: true };
  },

  /**
   * @param state
   */
  [C.REVIEW_APPROVAL_STATUS_APPROVE_PENDING](state) {
    state.approval = { ...state.approval, loading: true, error: false };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_APPROVAL_STATUS_DISAPPROVE_SUCCESS](state, payload) {
    state.approval = { ...state.approval, loading: false, error: false };
    state.approval.items.reviews = payload;
  },

  /**
   * @param state
   */
  [C.REVIEW_APPROVAL_STATUS_DISAPPROVE_FAILURE](state) {
    state.approval = { ...state.approval, loading: false, error: true };
  },

  /**
   * @param state
   */
  [C.REVIEW_APPROVAL_STATUS_DISAPPROVE_PENDING](state) {
    state.approval = { ...state.approval, loading: true, error: false };
  },

  /**
   * @param state
   */
  [C.REVIEW_FILTER_RESET_REVIEWS](state) {
    state.approval.items = { ...state.approval.items, offset: 0, hasMore: true, reviews: [] };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_BULK_SELECT_ALL](state, payload) {
    state.bulk = { ...state.bulk, reviewIds: payload };
  },

  /**
   * @param state
   */
  [C.REVIEW_BULK_DESELECT_ALL](state) {
    state.bulk = { ...state.bulk, reviewIds: [] };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_BULK_UPDATE_SELECT](state, payload) {
    state.bulk = { ...state.bulk, reviewIds: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_OVERVIEW_APPROVAL_STATUS_FILTER](state, payload) {
    state.overview = { ...state.overview, approvalStatusFilter: payload };
  },

  /**
   * @param state
   */
  [C.REVIEW_OVERVIEW_PENDING](state) {
    state.overview = { ...state.overview, loading: true, error: false, items: {} };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_OVERVIEW_SUCCESS](state, payload) {
    state.overview = { ...state.overview, loading: false, error: false, items: payload };
  },

  /**
   * @param state
   */
  [C.REVIEW_OVERVIEW_FAILURE](state) {
    state.overview = { ...state.overview, loading: false, error: true, items: {} };
  },

  /**
   * @param state
   */
  [C.REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_PENDING](state) {
    state.approval = { ...state.approval, loading: true, error: false };
  },


  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_SUCCESS](state, payload) {
    state.approval = { ...state.approval, loading: false, error: false };
    state.approval.items.reviews = payload;
  },

  /**
   * @param state
   */
  [C.REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_FAILURE](state) {
    state.approval = { ...state.approval, loading: false, error: true };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/review/mutations.js